import List from "@/components/visualizations/List/List";
import useTranslation from "@/hooks/useTranslation";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import { facilityIcon } from "@/pages/dashboard/FacilityDashboard/widgets/FacilityImpactTopContributors";
import {
  ProductBy,
  useProductProductionImpactPerSource,
} from "@/pages/dashboard/hooks/useProductImpact";
import { formatAmountWithUnit } from "@/pages/dashboard/utils/formatters";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { unitMapping } from "@/utilities/units";

function ProductionImpactPerSource({
  metric,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const translation = useTranslation();

  const { data, isLoading, isFetching } = useProductProductionImpactPerSource({
    productId,
    by,
    metric: metric.key,
  });

  const listData = data
    ? data
        ?.map((row) => {
          return {
            icon: facilityIcon(row.energy_type),
            label: row.name,
            value: row.impact[metric.key],
            extraProp: {
              value: formatAmountWithUnit(row.amount, unitMapping[row.unit] || row.unit, 2),
            },
          };
        })
        .sort((a, b) => (a.value > b.value ? -1 : 1))
    : [];

  const total = listData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Widget
      title={translation["productDrawer"]["productionImpactBySource"]["title"]}
      tooltip={translation["productDrawer"]["productionImpactBySource"]["description"]}
    >
      <List
        loading={isLoading || isFetching}
        data={{
          list: listData,
          total: total,
        }}
        format={metric.formatter}
      />
    </Widget>
  );
}

export default ProductionImpactPerSource;
